import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2

import GuestLayout from '../../layouts/GuestLayout';

import InputLabel from '../../components/InputLabel';
import PrimaryButton from '../../components/PrimaryButton';
import TextInput from '../../components/TextInput';
import Checkbox from '../../components/Checkbox'; // Assuming you have this

export default function Login() {
    const navigate = useNavigate();

    const [data, setData] = useState({
        email: '',
        password: '',
        remember: false,
    });

    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('wp_jwt')) {
            navigate('/dashboard');
        }

        return () => {
            setData((prev) => ({ ...prev, password: '' }));
        };
    }, [navigate]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const submit = async (e) => {
        e.preventDefault();
        setProcessing(true);
        const apiUrl = process.env.REACT_APP_WORDPRESS_URL;

        try {
            const response = await fetch(`${apiUrl}/wp-json/jwt-auth/v1/token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    username: data.email,
                    password: data.password,
                }),
            });

            const result = await response.json();

            if (response.ok) {
                localStorage.setItem('wp_jwt', result.token);
                localStorage.setItem('wp_user', JSON.stringify(result));
                // Show success message
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    html: "You have logged in successfully.",
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    navigate('/dashboard');
                });
            } else {
                // Show error message using Swal
                Swal.fire({
                    html: result.message || 'Login failed',
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 5000,
                    position: "bottom-end",
                });
            }
        } catch (error) {

            Swal.fire({
                html: 'Unexpected error occurred.',
                icon: 'error',
                showConfirmButton: false,
                timer: 3000,
                position: "bottom-end",
            });
        } finally {
            setProcessing(false);
        }
    };

    return (
        <GuestLayout>
            <h1 className="text-xl font-light text-center mb-4">Administratorska prijava tvrtki</h1>

            <form onSubmit={submit}>
                <div>
                    <InputLabel htmlFor="email" value="Korisničko ime" />
                    <TextInput
                        id="email"
                        type="text"
                        name="email"
                        value={data.email}
                        className="mt-1 block w-full"
                        autoComplete="username"
                        autoFocus
                        onChange={handleChange}
                    />
                </div>

                <div className="mt-4">
                    <InputLabel htmlFor="password" value="Lozinka" />
                    <TextInput
                        id="password"
                        type="password"
                        name="password"
                        value={data.password}
                        className="mt-1 block w-full"
                        autoComplete="current-password"
                        onChange={handleChange}
                    />
                </div>
                <div className="block mt-4">
                    <label className="flex items-center">
                        <Checkbox
                            name="remember"
                            checked={data.remember}
                            onChange={handleChange}
                        />
                        <span className="ml-2 text-sm text-gray-600">Zapamti me</span>
                    </label>
                </div>

                <div className="flex items-center justify-end mt-4">
                    <PrimaryButton type={'submit'} className="ml-4 " disabled={processing}>
                        {processing ? (
                            <div className="animate-spin border-2 border-t-2 border-white w-5 h-5 rounded-full"></div>
                        ) : (
                            'Prijavite se'
                        )}
                    </PrimaryButton>
                </div>
            </form>
        </GuestLayout>
    );
}
